// https://en.wikipedia.org/wiki/English_grammar
// https://en.wikipedia.org/wiki/Noun
export const wordTypes = {
  OTHER: 'OTHER',
  ADJECTIVE_POSSESSIVE: 'POSSESSIVE_ADJECTIVE',
  NOUN: 'NOUN',
  ADJECTIVE_QUALIFICATIVE: 'ADJECTIVE_QUALIFICATIVE',
  PARTICLE_VERBAL: 'PARTICLE_VERBAL',
  VERB: 'VERB',
  PRONOUN_PERSONAL: 'PRONOUN_PERSONAL',
  PRONOUN_POSSESSIVE: 'PRONOUN_POSSESSIVE',
  ARTICLE: 'ARTICLE',
  ADVERB: 'ADVERB',
  CONJUNCTION_SUBORDINATE: 'CONJUNCTION_SUBORDINATE',
  CONJUNCTION_COORDINATING: 'CONJUNCTION_COORDINATING',
  COMPARATIVE: 'COMPARATIVE',
  NUMBER: 'NUMBER',
  ORDINAL: 'ORDINAL',
  PREPOSITION: 'PREPOSITION',
  PRONOUN: 'PRONOUN',
  CARDINAL_BEFORE_SUBSTANTIF: 'CARDINAL_BEFORE_SUBSTANTIF',
};

export const wordGenders = {
  MASCULINE: 'MASCULINE',
  FEMININE: 'FEMININE',
};

export const wordNumbers = {
  SINGULAR: 'SINGULAR',
  PLURAL: 'PLURAL',
};

export const wordTopics = {
  PEOPLE: 'PEOPLE',
  OTHER: 'OTHER',
};

export const wordAttributes = {
  id: 'id',
  resultContent: 'resultContent',
  sourceContent: 'sourceContent',
  wordType: 'wordType',
  wordTypeChoices: 'wordTypeChoices',
  wordGender: 'wordGender',
  wordNumber: 'wordNumber',
  wordTopic: 'wordTopic',
  refForMutation: 'refForMutation',
  mutationCause: 'mutationCause',
};

export function Word () {
  this[ wordAttributes.id ] = `word-${Date.now()}`;
  this[ wordAttributes.resultContent ] = '';
  this[ wordAttributes.sourceContent ] = '';
  this[ wordAttributes.wordType ] = wordTypes.OTHER;
  this[ wordAttributes.wordGender ] = wordGenders.MASCULINE;
  this[ wordAttributes.wordNumber ] = wordNumbers.SINGULAR;
  this[ wordAttributes.refForMutation ] = wordAttributes.sourceContent;
  this[ wordAttributes.mutationCause ] = null;
  this[ wordAttributes.wordTypeChoices ] = [];
  this[ wordAttributes.wordTopic ] = wordTopics.OTHER;
}

Word.prototype.copy = function () {

  const copyWord = new Word();
  copyWord[ wordAttributes.resultContent ] = this[ wordAttributes.resultContent ];
  copyWord[ wordAttributes.sourceContent ] = this[ wordAttributes.sourceContent ];
  copyWord[ wordAttributes.wordType ] = this[ wordAttributes.wordType ];
  copyWord[ wordAttributes.wordGender ] = this[ wordAttributes.wordGender ];
  copyWord[ wordAttributes.wordNumber ] = this[ wordAttributes.wordNumber ];
  copyWord[ wordAttributes.refForMutation ] = this[ wordAttributes.refForMutation ];
  copyWord[ wordAttributes.mutationCause ] = this[ wordAttributes.mutationCause ];
  copyWord[ wordAttributes.wordTypeChoices ] = this[ wordAttributes.wordTypeChoices ];
  copyWord[ wordAttributes.wordTopic ] = this[ wordAttributes.wordTopic ];
  return copyWord;
};

Word.prototype.rawText = function (text) {
  this[ wordAttributes.sourceContent ] = text;
  return this;
};

Word.prototype.feminine = function () {
  this[ wordAttributes.wordGender ] = wordGenders.FEMININE;
  return this;
};

Word.prototype.masculine = function () {
  this[ wordAttributes.wordGender ] = wordGenders.MASCULINE;
  return this;
};

Word.prototype.isFeminine = function () {
  return this[ wordAttributes.wordGender ] === wordGenders.FEMININE;
};

Word.prototype.isMasculine = function () {
  return this[ wordAttributes.wordGender ] === wordGenders.MASCULINE;
};

Word.prototype.singular = function () {
  this[ wordAttributes.wordNumber ] = wordNumbers.SINGULAR;
  return this;
};

Word.prototype.plural = function () {
  this[ wordAttributes.wordNumber ] = wordNumbers.PLURAL;
  return this;
};

Word.prototype.isSingular = function () {
  return this[ wordAttributes.wordNumber ] === wordNumbers.SINGULAR;
};

Word.prototype.isPlural = function () {
  return this[ wordAttributes.wordNumber ] === wordNumbers.PLURAL;
};

Word.prototype.people = function () {
  this[ wordAttributes.wordTopic ] = wordTopics.PEOPLE;
  return this;
};

export function newNoun (text) {
  const word = new Word();
  // Word.call(this);
  word[ wordAttributes.sourceContent ] = text;
  word[ wordAttributes.wordType ] = wordTypes.NOUN;
  return word;
}

export function newArticle (text) {
  const word = new Word();
  word[ wordAttributes.sourceContent ] = text;
  word[ wordAttributes.wordType ] = wordTypes.ARTICLE;
  return word;
}

export function newNounFeminineSingular (text) {
  const word = new Word();
  word[ wordAttributes.sourceContent ] = text;
  word[ wordAttributes.wordType ] = wordTypes.NOUN;
  word[ wordAttributes.wordGender ] = wordGenders.FEMININE;
  word[ wordAttributes.wordNumber ] = wordNumbers.SINGULAR;
  return word;
}

export function newNounMasculineSingular (text) {
  const word = new Word();
  word[ wordAttributes.sourceContent ] = text;
  word[ wordAttributes.wordType ] = wordTypes.NOUN;
  word[ wordAttributes.wordGender ] = wordGenders.MASCULINE;
  word[ wordAttributes.wordNumber ] = wordNumbers.SINGULAR;
  return word;
}

export function newNounMasculinePluralPerson (text) {
  const word = new Word();
  word[ wordAttributes.sourceContent ] = text;
  word[ wordAttributes.wordType ] = wordTypes.NOUN;
  word[ wordAttributes.wordGender ] = wordGenders.MASCULINE;
  word[ wordAttributes.wordNumber ] = wordNumbers.PLURAL;
  word[ wordAttributes.wordTopic ] = wordTopics.PEOPLE;
  return word;
}

export function newAdjQual (text) {
  const word = new Word();
  word[ wordAttributes.sourceContent ] = text;
  word[ wordAttributes.wordType ] = wordTypes.ADJECTIVE_QUALIFICATIVE;
  return word;
}

export function newVerb (text) {
  const word = new Word();
  word[ wordAttributes.sourceContent ] = text;
  word[ wordAttributes.wordType ] = wordTypes.VERB;
  return word;
}

// Noun.prototype = Object.create(Word.prototype);
// Object.defineProperty(Noun.prototype, 'constructor', {
//   value: Noun,
//   enumerable: false, // so that it does not appear in 'for in' loop
//   writable: true,
// });

export function toLowerCase(text) {
  return text.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLocaleLowerCase();
}
